<template lang="pug">
  div
    .search-container
      search-bar(
        :placeHolder="searchBarPlaceholder",
        :hasCleanButton="true",
        @search="(searchValue) => handleSearch(searchValue)"
      )
    el-row(:gutter="20")
      el-col(:span="24")
        h2.custom-label Listagem de credenciados
      el-table.table(
        :data="listaCredenciados"
        :default-sort='{ prop: "situacao", order: "ascending" }'
        @sort-change="sort"
        v-loading="loading"
      )
        template(slot="empty") Não foram encontrados credenciados com os dados informados
        el-table-column(
          label="Situação",
          header-align="center",
          align="center"
          sortable="custom"
          prop="situacao"
        )
          template(slot-scope="scope")
            el-tooltip(
                :content="scope.row.situacao == 'ATIVO' ? 'ATIVO' : 'INATIVO' ",
                placement="top",
                effect="dark"
              )
              i(:class="verifySituacao(scope.row.situacao)")
        el-table-column(
          v-for="col in tipoEdital === 'GEOMENSOR' ? columnsGeomensor : columnsVistoriador",
          :prop="col.key",
          :label="col.label",
          :key="col.codigo",
          :sortable="col.order",
        )

    Pagination(:total="quantidadeResultados" :pagina="paginaAtual" :tamanhoPagina="tamanhoPagina" @changePage="changePage")
    el-row
      el-col(:span="24")
        .export-button-container
          el-button(type="primary" @click='handleExport')
            span Exportar
            span.fas.fa-download
</template>

<script>
import { SearchBar, Table, Pagination } from 'sicarf-components'
import { findCredenciadosByFiltro, exportCSVListagemCredenciados } from '@/services/credenciadoService';
import { getTipoByUser } from '@/services/editalService';
import situacoes from '@/constants/situacoes';
import AppModalEdital from '@/components/AppModalEdital';
import { saveAs } from 'file-saver';

export default {
  components: {
    SearchBar,
    Table,
    Pagination,
    AppModalEdital
  },
  data () {
    return {
      isModalVisible: false,
      filtro: {},
      filtroSort: {},
      editalVigente: null,
      searchBarPlaceholder: 'Informe o nome ou CPF do credenciado',
      listaCredenciados: [],
      quantidadeResultados: 0,
      paginaAtual: 0,
      tamanhoPagina: 15,
      loading: false,
      tipoEdital: '',
      columnsGeomensor: [
        { key: 'pessoa.pessoaFisica.nome', label: 'Nome', order: 'custom', codigo: 'NOME' },
        { key: 'pessoa.pessoaFisica.cpf', label: 'CPF', codigo: 'CPF' },
        { key: 'codigoIncra', label: 'Código do INCRA', codigo: 'CODIGO_INCRA' },
        { key: 'codigoCrea', label: 'Registro no conselho', codigo: 'REGISTRO_CONSELHO' },
        { key: 'pessoa.email', label: 'E-mail', codigo: 'EMAIL' },
        { key: 'responsavel.pessoa.pessoaFisica.nome', label: 'Responsável pelo credenciamento', codigo: 'RESPONSAVEL' }
      ],
      columnsVistoriador: [
        { key: 'pessoa.pessoaFisica.nome', label: 'Nome', order: 'custom', codigo: 'NOME' },
        { key: 'pessoa.pessoaFisica.cpf', label: 'CPF', codigo: 'CPF' },
        { key: 'codigoCrea', label: 'Registro no conselho', codigo: 'REGISTRO_CONSELHO' },
        { key: 'pessoa.email', label: 'E-mail', codigo: 'EMAIL' },
        { key: 'responsavel.pessoa.pessoaFisica.nome', label: 'Responsável pelo credenciamento', codigo: 'RESPONSAVEL' }
      ],
    }
  },
  async mounted () {
    this.loading = true;
    this.tipoEdital = await getTipoByUser();
    this.filtroSort.ordem = 'situacao';
    this.filtroSort.ordemDirecao = 'ASC';
    this.handleSearch();
  },
  methods: {
    async handleSearch (searchValue, pagina = 0) {
      this.loading = true;
      this.filtro = {}
      this.filtro.campoSimples = searchValue || '';
      this.filtro.pagina = pagina;
      this.filtro.ordem = this.filtroSort.ordem;
      this.filtro.ordemDirecao = this.filtroSort.ordemDirecao;
      const resp = await findCredenciadosByFiltro(this.filtro);
      this.listaCredenciados = resp.content;
      this.quantidadeResultados = resp.totalElements;
      this.loading = false;
    },
    changePage (newPage) {
      this.paginaAtual = newPage - 1;
      this.handleSearch(this.filtro.campoSimples, this.paginaAtual);
    },
    sort (item) {
      this.filtroSort.ordem = item.prop;
      if (item.order === 'ascending') {
        this.filtroSort.ordemDirecao = 'ASC';
      } else {
        this.filtroSort.ordemDirecao = 'DESC';
      }
      this.handleSearch(this.filtro.campoSimples, this.paginaAtual);
    },
    verifySituacao (situacao) {
      switch (situacao) {
        case situacoes.ATIVO:
          return 'fas fa-check greenColor';
        case situacoes.INATIVO:
          return 'fas fa-minus';
        default:
          return '';
      }
    },
    async handleExport () {
      let tipoEdital = this.tipoEdital.toLowerCase()
      const csv = await exportCSVListagemCredenciados()
      saveAs(csv, `relatorio_listagem_credenciados_${tipoEdital}.csv`)
    }
  },
}
</script>

<style lang="scss">
@import "@/assets/styles/_variables.scss";

.custom-label{
    font-size: $font-size-medium;
    text-align: left;
    color: #606266;
  }
.marginLeft {
  margin-left: 5px;
}
.cadastrar {
  float: right;
}
.marginRight {
  margin-right: 10px;
}
.groups-title {
  padding-left: 10px;
  text-align: start;
  display: flex;
}
.text-center {
  text-align: center;
}
.redColor {
  color: $error;
}
.greenColor {
  color: $color-primary;
}
.yellowColor {
  color: $warning;
}
.not-found-text {
  color: $font-color;
}
.textDropdown {
  margin-left: 5px;
}

.export-button-container {
  display: flex;
  justify-content: flex-end;

  .fas {
    margin-left: 10px;
  }
}

</style>
